import { render, staticRenderFns } from "./ProviderList.vue?vue&type=template&id=d7187ac4&"
import script from "./ProviderList.vue?vue&type=script&lang=js&"
export * from "./ProviderList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d7187ac4')) {
      api.createRecord('d7187ac4', component.options)
    } else {
      api.reload('d7187ac4', component.options)
    }
    module.hot.accept("./ProviderList.vue?vue&type=template&id=d7187ac4&", function () {
      api.rerender('d7187ac4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/routing/global/ProviderList.vue"
export default component.exports